import OrganicTopShape from 'themes/organic/assets/organic_top_shape.svg';

import { useBnplBanner } from 'hooks/bnpl/useBnplBanner';

import { BuyNowPayLaterBanner } from 'routes/home/components/BuyNowPayLaterBanner/BuyNowPayLaterBanner';

import { OrganicFooter } from '../Footer/OrganicFooter';
import { OrganicNavigation } from '../OrganicNavigation/OrganicNavigation';

import s from './OrganicLayout.module.css';

interface TProps {
  children: React.ReactNode;
}

export const OrganicLayout = ({ children }: TProps) => {
  const {
    elementRef,
    showBanner,
    bannerContainerStyle,
    onDismissBanner,
    isDismissed,
    bnplCapabilities,
    isLoading,
  } = useBnplBanner();

  return (
    <div className={s.layout} style={bannerContainerStyle}>
      {showBanner && (
        <BuyNowPayLaterBanner
          ref={elementRef}
          onDismissBanner={onDismissBanner}
          isDismissed={isDismissed}
          capabilities={bnplCapabilities}
          isLoading={isLoading}
        />
      )}
      <div className={s.topShapeContainer}>
        <OrganicTopShape />
      </div>
      <OrganicNavigation />
      <div className={s.container}>{children}</div>
      <OrganicFooter />
    </div>
  );
};
